import React from 'react'
import { View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'
import useWindowDimensions from 'hooks/useWindowDimensions'

const Wrapper = (
  {
    children,
    isReusableComponent,
    isResponsiveComponent,
    object: { layout: _layout },
  },
  { getOffsetTop }
) => {
  let layout = { ..._layout }
  if (isReusableComponent) {
    layout = { ...layout, flex: undefined }
  }

  const { height } = useWindowDimensions()

  if (isResponsiveComponent) {
    layout.height = height - getOffsetTop()
    delete layout.flex
  }

  return (
    <View style={[styles.wrapper, layout]} pointerEvents="box-none">
      {children}
    </View>
  )
}

Wrapper.contextTypes = {
  getOffsetTop: PropTypes.func,
}

const styles = StyleSheet.create({
  wrapper: {},
})

export default Wrapper
